module.exports = __webpack_public_path__ + "img/fatherhood_2.987d8bd2.jpg";